import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export const usuarioAutenticadoGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let usuarioLogado = inject(AuthenticationService).canActivate();

  // return true;

  if (usuarioLogado) {
    return true;
  } else {
    console.log('nao autenticado, voltando login')
    inject(Router).navigate(['/']);
    return false;
  }
};
